import React, { useEffect, useState, lazy } from 'react';
import { Phone, Mail, MapPin, Clock, Send } from 'lucide-react';
import { CTABanner } from '../components/CTABanner';
export function Contact() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    serviceType: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success'>('idle');
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    // Simulate API call
    setTimeout(() => {
      setIsSubmitting(false);
      setSubmitStatus('success');
      setFormData({
        name: '',
        phone: '',
        email: '',
        serviceType: '',
        message: ''
      });
      // Reset success message after 5 seconds
      setTimeout(() => setSubmitStatus('idle'), 5000);
    }, 1500);
  };
  return <div className="w-full" data-id="element-302" data-mp="1e80mrcq6gfvh">
      {/* Hero */}
      <section className="relative pt-32 pb-20 md:pt-40 md:pb-28 overflow-hidden bg-navy" data-id="element-303" data-mp="1e8ab6vvkqez2">
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1423666639041-f56000c27a9a?w=1200')] bg-cover bg-center opacity-20" data-id="element-304" data-mp="1j5in4eq4pmrv"></div>
        <div className="relative z-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-305" data-mp="qhwkb8oq6m62">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-montserrat font-black text-white mb-6" data-id="element-306" data-mp="vhiu185chka4">
            Get a Free Quote
          </h1>
          <p className="text-xl text-cream max-w-3xl mx-auto" data-id="element-307" data-mp="10h5b5soanko7">
            Ready to restore your property's beauty? Contact us today for a
            fast, free, no-obligation estimate.
          </p>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-16 md:py-24 bg-gray-50" data-id="element-308" data-mp="1m6u5guedqfhp">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-309" data-mp="1m5iry2v4ttde">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-310" data-mp="1h78utmpukip5">
            {/* Contact Form */}
            <div className="bg-white p-8 md:p-10 rounded-2xl shadow-xl border border-gray-100" data-id="element-311" data-mp="1w4i25pvjpx2i">
              <h2 className="text-3xl font-montserrat font-bold text-navy mb-6" data-id="element-312" data-mp="1r7hu59f4yk8r">
                Send Us a Message
              </h2>

              {submitStatus === 'success' && <div className="mb-6 p-4 bg-green-50 text-green-700 rounded-lg border border-green-200 flex items-center" data-id="element-313" data-mp="yiau26019mle">
                  <div className="w-2 h-2 bg-green-500 rounded-full mr-2" data-id="element-314" data-mp="1d7gv7ziflmvx"></div>
                  Thank you! Your message has been sent. We'll be in touch
                  shortly.
                </div>}

              <form onSubmit={handleSubmit} className="space-y-6" data-id="element-315" data-mp="kojn95dosgtd">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-316" data-mp="fq8d0tjhc4am">
                  <div data-id="element-317" data-mp="2rewp1rmisbyp">
                    <label htmlFor="name" className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-318" data-mp="2rdllnswzl684">
                      Full Name *
                    </label>
                    <input type="text" id="name" name="name" required value={formData.name} onChange={handleChange} className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-light-blue focus:border-light-blue transition-colors outline-none" placeholder="John Doe" data-id="element-319" data-mp="2hia6xalkvz0d" />
                  </div>
                  <div data-id="element-320" data-mp="3584h1keij9gx">
                    <label htmlFor="phone" className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-321" data-mp="1ppj76q4ors6d">
                      Phone Number *
                    </label>
                    <input type="tel" id="phone" name="phone" required value={formData.phone} onChange={handleChange} className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-light-blue focus:border-light-blue transition-colors outline-none" placeholder="586-298-2727" data-id="element-322" data-mp="29z2hl4x4liln" />
                  </div>
                </div>

                <div data-id="element-323" data-mp="2nvpjzn7ul0yy">
                  <label htmlFor="email" className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-324" data-mp="2iyfi3839uwu8">
                    Email Address *
                  </label>
                  <input type="email" id="email" name="email" required value={formData.email} onChange={handleChange} className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-light-blue focus:border-light-blue transition-colors outline-none" placeholder="john@example.com" data-id="element-325" data-mp="17jsinko80cs1" />
                </div>

                <div data-id="element-326" data-mp="3sxqpi6dhoh7x">
                  <label htmlFor="serviceType" className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-327" data-mp="3sy9ukmi1jb4j">
                    Service Needed
                  </label>
                  <select id="serviceType" name="serviceType" value={formData.serviceType} onChange={handleChange} className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-light-blue focus:border-light-blue transition-colors outline-none bg-white" data-id="element-328" data-mp="6rbmlsuhwdo8">
                    <option value="" data-id="element-329" data-mp="2hjd5xdprqnxp">Select a service...</option>
                    <option value="Residential" data-id="element-330" data-mp="3kt8uuc948gwf">
                      Residential Soft Washing
                    </option>
                    <option value="Roof" data-id="element-331" data-mp="3fvfq7nngnuy9">Roof Cleaning</option>
                    <option value="Gutter" data-id="element-332" data-mp="3tu6xaq3wogcw">Gutter Cleaning</option>
                    <option value="Driveway" data-id="element-333" data-mp="3ouataqv7koxc">Driveway & Concrete</option>
                    <option value="Deck" data-id="element-334" data-mp="3ow5f07eb0l2h">Deck & Patio</option>
                    <option value="Fence" data-id="element-335" data-mp="7kmjq2d15dh0">Fence Cleaning</option>
                    <option value="Commercial" data-id="element-336" data-mp="2n2y2he05yf1">Commercial Services</option>
                    <option value="Other" data-id="element-337" data-mp="2l05pqpdnt75">Other / Multiple</option>
                  </select>
                </div>

                <div data-id="element-338" data-mp="ccw658exrvej">
                  <label htmlFor="message" className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-339" data-mp="cce2hqpy2ewl">
                    How can we help? *
                  </label>
                  <textarea id="message" name="message" required rows={4} value={formData.message} onChange={handleChange} className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-light-blue focus:border-light-blue transition-colors outline-none resize-none" placeholder="Tell us about your property and what needs cleaning..." data-id="element-340" data-mp="levnk1tv51i0"></textarea>
                </div>

                <button type="submit" disabled={isSubmitting} className="w-full bg-navy text-white font-bold py-4 px-8 rounded-lg hover:bg-light-blue transition-colors flex items-center justify-center disabled:opacity-70 disabled:cursor-not-allowed" data-id="element-341" data-mp="qzl2x2hszuh8">
                  {isSubmitting ? <span className="flex items-center" data-id="element-342" data-mp="3c4moy7tbq6n">
                      <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" data-id="element-343" data-mp="7a2bw11l2ca1">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" data-id="element-344" data-mp="ds5peb3dcvmp"></circle>
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" data-id="element-345" data-mp="10m8z0sll7m"></path>
                      </svg>
                      Sending...
                    </span> : <span className="flex items-center" data-id="element-346" data-mp="3d8vbwqwzw7ah">
                      <Send className="w-5 h-5 mr-2" data-id="element-347" data-mp="1spruymuir22s" />
                      Get My Free Quote
                    </span>}
                </button>
              </form>
            </div>

            {/* Contact Info */}
            <div className="space-y-8" data-id="element-348" data-mp="21q6iztyvav9z">
              <div className="bg-navy text-white p-8 rounded-2xl shadow-xl relative overflow-hidden" data-id="element-349" data-mp="21r9b257xf3rh">
                <div className="absolute top-0 right-0 -mr-10 -mt-10 w-40 h-40 bg-light-blue opacity-20 rounded-full blur-2xl" data-id="element-350" data-mp="26ngfftkoc77b"></div>
                <h3 className="text-2xl font-montserrat font-bold mb-8 relative z-10" data-id="element-351" data-mp="1e0lvqyvolbuw">
                  Contact Information
                </h3>

                <div className="space-y-6 relative z-10" data-id="element-352" data-mp="1iydqe0npnc2s">
                  <div className="flex items-start" data-id="element-353" data-mp="1nr6v4oj6ikev">
                    <div className="w-12 h-12 bg-white/10 rounded-full flex items-center justify-center shrink-0 mr-4" data-id="element-354" data-mp="1nrzv96nmubo1">
                      <Phone className="w-6 h-6 text-light-blue" data-id="element-355" data-mp="vadz8zmhljno" />
                    </div>
                    <div data-id="element-356" data-mp="v819i0ahm502">
                      <p className="text-sm text-cream mb-1" data-id="element-357" data-mp="oy3ue0ic7yww">Call or Text Us</p>
                      <a href="tel:586-298-2727" className="text-xl font-bold hover:text-light-blue transition-colors" data-id="element-358" data-mp="twowy6l2auoi">
                        586-298-2727
                      </a>
                    </div>
                  </div>

                  <div className="flex items-start" data-id="element-359" data-mp="674f5r0na3gt">
                    <div className="w-12 h-12 bg-white/10 rounded-full flex items-center justify-center shrink-0 mr-4" data-id="element-360" data-mp="68nsp9ux20ew">
                      <Mail className="w-6 h-6 text-light-blue" data-id="element-361" data-mp="b436k1sxbwbb" />
                    </div>
                    <div data-id="element-362" data-mp="g3zak11mfnqv">
                      <p className="text-sm text-cream mb-1" data-id="element-363" data-mp="kw0jbczkywc5">Email Us</p>
                      <a href="mailto:SoftwashPros@gmail.com" className="text-lg font-bold hover:text-light-blue transition-colors break-all" data-id="element-364" data-mp="kxbo9g4ria4u">
                        SoftwashPros@gmail.com
                      </a>
                    </div>
                  </div>

                  <div className="flex items-start" data-id="element-365" data-mp="21onjm58n73to">
                    <div className="w-12 h-12 bg-white/10 rounded-full flex items-center justify-center shrink-0 mr-4" data-id="element-366" data-mp="21p5nno1jqmc5">
                      <Clock className="w-6 h-6 text-light-blue" data-id="element-367" data-mp="1wr44l344en0o" />
                    </div>
                    <div data-id="element-368" data-mp="1rsap5559wlxv">
                      <p className="text-sm text-cream mb-1" data-id="element-369" data-mp="1mqv5nhiqunhl">Business Hours</p>
                      <p className="font-bold" data-id="element-370" data-mp="1msy5sudm1x01">Mon - Sat: 7:00 AM - 7:00 PM</p>
                      <p className="text-cream text-sm" data-id="element-371" data-mp="1hz3mvt5txm20">
                        Sunday: By Appointment
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Map */}
              <div className="bg-gray-200 rounded-2xl h-64 overflow-hidden shadow-inner border border-gray-300" data-id="element-372" data-mp="140cacb6m88fz">
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d377194.4741488056!2d-83.56847055000001!3d42.59850125!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8824ca0110cb1d75%3A0x5776864e35b9c4d2!2sDetroit%20Metropolitan%20Area%2C%20MI!5e0!3m2!1sen!2sus!4v1715000000000!5m2!1sen!2sus" width="100%" height="100%" style={{
                border: 0
              }} allowFullScreen={false} loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Service Area Map - Detroit Metropolitan Area" data-id="element-373" data-mp="z1980yi0sgbp"></iframe>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>;
}